import styled from "styled-components";
import { Calendar } from 'react-big-calendar'
import { COLORS } from '../../../../constants/design'

export const StyledCalender = styled(Calendar)`
  /* width: 90vw; */
  height: 85vh;
  padding: 10px 20px;
  .rbc-toolbar {
    .rbc-toolbar-label {
      text-transform: capitalize;
      font-weight: 600;
      font-size: 1.1rem;
    }
    button {
      font-size: 0.85rem;
      padding: 10px 20px;
      cursor: pointer;
      border: 1px solid;
      border-color: ${COLORS.WHITE};
      background-color: ${COLORS.LIGHT_GREY_1};
      color: ${COLORS.DARK_GREY};
    }
    button:focus {
      background-color: ${COLORS.PRIMARY_BLUE};
      color: ${COLORS.WHITE};
      border-color: ${COLORS.WHITE};
    }
    button:active,
    button.rbc-active {
      background-color: ${COLORS.PRIMARY_BLUE};
      color: ${COLORS.WHITE};
      border-color: ${COLORS.WHITE};
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0);
    }
    button:active:hover,
    button:active:focus,
    button.rbc-active:hover,
    button.rbc-active:focus {
      background-color: ${COLORS.PRIMARY_BLUE};
      color: ${COLORS.WHITE};
      border-color: ${COLORS.WHITE};
    }
    .rbc-btn-group > button:first-child:not(:last-child) {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }
    .rbc-btn-group > button:last-child:not(:first-child) {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }
  .rbc-agenda-view table.rbc-agenda-table thead > tr > th { // agenda header
    display: table-cell;
    padding: 11px;
  }
  .rbc-header { // all other view header
    font-size: 0.8rem;
    padding: 12px;
    display: table-cell;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    a {
      padding: 10px;
    }
  }
  .rbc-row-segment { // for the event slot container
    padding: 2px 5px 0px 5px;
  }
  .rbc-event, .rbc-day-slot .rbc-background-event { // for the event slot
    padding: 5px 10px;
    font-size: 0.8rem;
    background-color: ${COLORS.PRIMARY_BLUE};
    color: ${COLORS.WHITE};
    border-color: ${COLORS.WHITE};
  }
  .rbc-event.rbc-selected, .rbc-day-slot .rbc-selected.rbc-background-event {
    background-color: ${COLORS.PRIMARY_DEEP_BLUE};
  }
  .rbc-event:focus, .rbc-day-slot .rbc-background-event:focus {
    outline: none;
  }
  .rbc-show-more {
    font-weight: 500;
    text-decoration: none;
    font-size: 0.7rem;
    padding: 5px 5px;
    color: ${COLORS.DARK_GREY};
  }
  .rbc-date-cell {
    padding: 5px 10px 0px 0px;
    display: flex;
    justify-content: flex-end;
    a {
      height: 25px;
      width: 25px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      :hover {
        background-color: ${COLORS.PRIMARY_BLUE};
        color: ${COLORS.WHITE};
      }
    }
  }
  .rbc-today {
    background-color: rgba(53, 126,211, 0.1);
  }
  .rbc-off-range-bg {
    background-color: ${COLORS.LIGHT_GREY_1};
  }
  .rbc-off-range {
    a {
      :hover {
        background-color: ${COLORS.LIGHT_GREY_2};
        color: ${COLORS.DARK_GREY};
      }
    }
  }
  .rbc-current-time-indicator { // className for current-time-indicator
    height: 1.5px;
    background-color: ${COLORS.RED_4};
  }
  .taskWrapper { // custom className for different event wrapper styling
    background-color: ${COLORS.GREEN};
  }
  .taskWrapperSelected.rbc-event.rbc-selected {
    background-color: ${COLORS.GREEN_2};
  }
  .rbc-event-label {
    /* display: none; */
    margin-bottom: 2px;
  }
`;
